import { render, staticRenderFns } from "./addBusinessTableHis.vue?vue&type=template&id=453f9d4a"
import script from "./addBusinessTableHis.vue?vue&type=script&lang=js"
export * from "./addBusinessTableHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports